import { throttle } from "Helper/functionHelper/decorators";
import { onEvent } from "@kluntje/js-utils/lib/dom-helpers";
import { getCurrentMQ } from "Helper/domHelper";

export type MQ = "MQ1" | "MQ2" | "MQ3" | "MQ4" | "MQ5";

class MediaQueryService {
  eventIdMap: WeakMap<HTMLElement | Function, string>;
  eventBindingMap: object;
  private _lastMQ: MQ; /** @example "MQ2" */
  private _currentMQ: MQ;

  constructor() {
    this.eventIdMap = new WeakMap();
    this.eventBindingMap = {};
    this._lastMQ = getCurrentMQ() as MQ;
    this._currentMQ = getCurrentMQ() as MQ;
    onEvent(window, "resize", this.handleResize, this);
  }

  @throttle(100)
  handleResize() {
    const newMQ = getCurrentMQ() as MQ;
    const mqChanged = newMQ !== this._currentMQ;

    if (mqChanged) this._lastMQ = this._currentMQ;
    this._currentMQ = newMQ;

    window.dispatchEvent(new CustomEvent("fra-resize"));

    if (mqChanged) {
      window.dispatchEvent(
        new CustomEvent("fra-mq-change", {
          detail: {
            newMQ,
            oldMQ: this._lastMQ,
          },
        }),
      );
    }
  }

  get currentMQ() {
    return this._currentMQ;
  }

  get lastMQ() {
    return this._lastMQ;
  }
}

export default new MediaQueryService();
